/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { CompanyGlMappingsEnvelope } from '../models/companyGlMappingsEnvelope';

import type { CompanyGlMappingsRequest } from '../models/companyGlMappingsRequest';

import type { CompanyTaxIdEnvelope } from '../models/companyTaxIdEnvelope';

import type { GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetParams } from '../models/getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetParams';

import type { GlMappingsCoverageEnvelope } from '../models/glMappingsCoverageEnvelope';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ModulesAccountingApiSettingsRoutesTenantSettingsRequest } from '../models/modulesAccountingApiSettingsRoutesTenantSettingsRequest';

import type { ModulesAccountingApiSettingsRoutesUserSettingsRequest } from '../models/modulesAccountingApiSettingsRoutesUserSettingsRequest';

import type { OperationalDefaultsEnvelope } from '../models/operationalDefaultsEnvelope';

import type { UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutParams } from '../models/updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutParams';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Get current user's accounting settings.
 * @summary Get User Settings
 */
export const getUserSettingsApiV1AccountingSettingsUserGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/settings/user`,
    method: 'GET',
    signal
  });
};

export const getGetUserSettingsApiV1AccountingSettingsUserGetQueryKey = () => {
  return [`/api/v1/accounting/settings/user`] as const;
};

export const getGetUserSettingsApiV1AccountingSettingsUserGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserSettingsApiV1AccountingSettingsUserGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>>
  > = ({ signal }) => getUserSettingsApiV1AccountingSettingsUserGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserSettingsApiV1AccountingSettingsUserGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>>
  >;
export type GetUserSettingsApiV1AccountingSettingsUserGetQueryError = unknown;

export function useGetUserSettingsApiV1AccountingSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserSettingsApiV1AccountingSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserSettingsApiV1AccountingSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Settings
 */

export function useGetUserSettingsApiV1AccountingSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1AccountingSettingsUserGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetUserSettingsApiV1AccountingSettingsUserGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update current user's accounting settings.
 * @summary Update User Settings
 */
export const updateUserSettingsApiV1AccountingSettingsUserPut = (
  modulesAccountingApiSettingsRoutesUserSettingsRequest: ModulesAccountingApiSettingsRoutesUserSettingsRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/settings/user`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modulesAccountingApiSettingsRoutesUserSettingsRequest
  });
};

export const getUpdateUserSettingsApiV1AccountingSettingsUserPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateUserSettingsApiV1AccountingSettingsUserPut>
      >,
      TError,
      { data: ModulesAccountingApiSettingsRoutesUserSettingsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateUserSettingsApiV1AccountingSettingsUserPut>
    >,
    TError,
    { data: ModulesAccountingApiSettingsRoutesUserSettingsRequest },
    TContext
  > => {
    const mutationKey = ['updateUserSettingsApiV1AccountingSettingsUserPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateUserSettingsApiV1AccountingSettingsUserPut>
      >,
      { data: ModulesAccountingApiSettingsRoutesUserSettingsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return updateUserSettingsApiV1AccountingSettingsUserPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateUserSettingsApiV1AccountingSettingsUserPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateUserSettingsApiV1AccountingSettingsUserPut>>
  >;
export type UpdateUserSettingsApiV1AccountingSettingsUserPutMutationBody =
  ModulesAccountingApiSettingsRoutesUserSettingsRequest;
export type UpdateUserSettingsApiV1AccountingSettingsUserPutMutationError =
  HTTPValidationError;

/**
 * @summary Update User Settings
 */
export const useUpdateUserSettingsApiV1AccountingSettingsUserPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateUserSettingsApiV1AccountingSettingsUserPut>
      >,
      TError,
      { data: ModulesAccountingApiSettingsRoutesUserSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserSettingsApiV1AccountingSettingsUserPut>>,
  TError,
  { data: ModulesAccountingApiSettingsRoutesUserSettingsRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateUserSettingsApiV1AccountingSettingsUserPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get tenant's accounting settings. Requires module admin.
 * @summary Get Tenant Settings
 */
export const getTenantSettingsApiV1AccountingSettingsTenantGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/settings/tenant`,
    method: 'GET',
    signal
  });
};

export const getGetTenantSettingsApiV1AccountingSettingsTenantGetQueryKey =
  () => {
    return [`/api/v1/accounting/settings/tenant`] as const;
  };

export const getGetTenantSettingsApiV1AccountingSettingsTenantGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTenantSettingsApiV1AccountingSettingsTenantGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
      >
    > = ({ signal }) =>
      getTenantSettingsApiV1AccountingSettingsTenantGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTenantSettingsApiV1AccountingSettingsTenantGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
    >
  >;
export type GetTenantSettingsApiV1AccountingSettingsTenantGetQueryError =
  unknown;

export function useGetTenantSettingsApiV1AccountingSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantSettingsApiV1AccountingSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantSettingsApiV1AccountingSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Settings
 */

export function useGetTenantSettingsApiV1AccountingSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1AccountingSettingsTenantGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantSettingsApiV1AccountingSettingsTenantGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update tenant's accounting settings. Requires module admin.
 * @summary Update Tenant Settings
 */
export const updateTenantSettingsApiV1AccountingSettingsTenantPut = (
  modulesAccountingApiSettingsRoutesTenantSettingsRequest: ModulesAccountingApiSettingsRoutesTenantSettingsRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/settings/tenant`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modulesAccountingApiSettingsRoutesTenantSettingsRequest
  });
};

export const getUpdateTenantSettingsApiV1AccountingSettingsTenantPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTenantSettingsApiV1AccountingSettingsTenantPut>
      >,
      TError,
      { data: ModulesAccountingApiSettingsRoutesTenantSettingsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateTenantSettingsApiV1AccountingSettingsTenantPut>
    >,
    TError,
    { data: ModulesAccountingApiSettingsRoutesTenantSettingsRequest },
    TContext
  > => {
    const mutationKey = [
      'updateTenantSettingsApiV1AccountingSettingsTenantPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateTenantSettingsApiV1AccountingSettingsTenantPut>
      >,
      { data: ModulesAccountingApiSettingsRoutesTenantSettingsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return updateTenantSettingsApiV1AccountingSettingsTenantPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTenantSettingsApiV1AccountingSettingsTenantPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateTenantSettingsApiV1AccountingSettingsTenantPut>
    >
  >;
export type UpdateTenantSettingsApiV1AccountingSettingsTenantPutMutationBody =
  ModulesAccountingApiSettingsRoutesTenantSettingsRequest;
export type UpdateTenantSettingsApiV1AccountingSettingsTenantPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Settings
 */
export const useUpdateTenantSettingsApiV1AccountingSettingsTenantPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTenantSettingsApiV1AccountingSettingsTenantPut>
      >,
      TError,
      { data: ModulesAccountingApiSettingsRoutesTenantSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateTenantSettingsApiV1AccountingSettingsTenantPut>
  >,
  TError,
  { data: ModulesAccountingApiSettingsRoutesTenantSettingsRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateTenantSettingsApiV1AccountingSettingsTenantPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Tenant accounting defaults an ordinary member needs to do their work.

Gated on module ACCESS (`viewer`), not on bare `require_auth`, and not on
module admin:

* These are accounting operational values — which GL account revenue lands
  on, when the fiscal year turns, what routes a payment run to approval — so
  the reader should at least be somebody the tenant has given the accounting
  module to. `require_module_access` is opt-in down-scoping (a user with no
  explicit per-module entry resolves to `member`), so this refuses only a
  user an admin has deliberately restricted out of accounting, and it is
  exactly how this module's other member-open reads are spelled (the user
  settings tier of the factory above, `ar_routes`, `ap_reports_routes`).
* None of the four is sensitive to such a reader. Two are GL/config ids the
  member's own line editor is about to show them anyway; the two AP approval
  fields describe a control the payment run's own status already reveals,
  and withholding them is precisely what makes the page unable to say why a
  run is waiting.

READ-ONLY: there is no write verb on this path. The admin tenant settings
GET/PUT keep their `require_module_admin("accounting")` gate unchanged — this
route adds a door for the reader, it does not widen theirs.
 * @summary Get Operational Defaults
 */
export const getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet =
  (signal?: AbortSignal) => {
    return customInstance<OperationalDefaultsEnvelope>({
      url: `/api/v1/accounting/settings/operational-defaults`,
      method: 'GET',
      signal
    });
  };

export const getGetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGetQueryKey =
  () => {
    return [`/api/v1/accounting/settings/operational-defaults`] as const;
  };

export const getGetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
        >
      >
    > = ({ signal }) =>
      getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
      >
    >
  >;
export type GetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGetQueryError =
  unknown;

export function useGetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Operational Defaults
 */

export function useGetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOperationalDefaultsApiV1AccountingSettingsOperationalDefaultsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Reveal the tenant-wide company tax ID (EIN) in clear. Requires module admin.

Used by the reveal control on Accounting -> Setup -> Company Details. The value
is never logged.
 * @summary Get Company Tax Id
 */
export const getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet = (
  signal?: AbortSignal
) => {
  return customInstance<CompanyTaxIdEnvelope>({
    url: `/api/v1/accounting/settings/company-tax-id`,
    method: 'GET',
    signal
  });
};

export const getGetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGetQueryKey =
  () => {
    return [`/api/v1/accounting/settings/company-tax-id`] as const;
  };

export const getGetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet>
      >
    > = ({ signal }) =>
      getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet>
    >
  >;
export type GetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGetQueryError =
  unknown;

export function useGetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet<
  TData = Awaited<
    ReturnType<typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet<
  TData = Awaited<
    ReturnType<typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet<
  TData = Awaited<
    ReturnType<typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Company Tax Id
 */

export function useGetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet<
  TData = Awaited<
    ReturnType<typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCompanyTaxIdApiV1AccountingSettingsCompanyTaxIdGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get one company's GL account-role overrides. Requires module admin.

``company_id`` defaults to the caller's active company (app-bar scope), which
is the only possible company on a single-company tenant.
 * @summary Get Company Gl Mappings
 */
export const getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet = (
  params?: GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<CompanyGlMappingsEnvelope>({
    url: `/api/v1/accounting/settings/company-gl-mappings`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetQueryKey =
  (
    params?: GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetParams
  ) => {
    return [
      `/api/v1/accounting/settings/company-gl-mappings`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
        >
      >
    > = ({ signal }) =>
      getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
      >
    >
  >;
export type GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetQueryError =
  HTTPValidationError;

export function useGetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet<
  TData = Awaited<
    ReturnType<
      typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet<
  TData = Awaited<
    ReturnType<
      typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet<
  TData = Awaited<
    ReturnType<
      typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Company Gl Mappings
 */

export function useGetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet<
  TData = Awaited<
    ReturnType<
      typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set/clear one company's GL account-role overrides. Requires module admin.

Each account is validated against the role's allowed account types AND
against the company's effective chart of accounts — mapping another
company's account would make every posting for this company a cross-company
journal entry.
 * @summary Update Company Gl Mappings
 */
export const updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut =
  (
    companyGlMappingsRequest: CompanyGlMappingsRequest,
    params?: UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutParams
  ) => {
    return customInstance<CompanyGlMappingsEnvelope>({
      url: `/api/v1/accounting/settings/company-gl-mappings`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: companyGlMappingsRequest,
      params
    });
  };

export const getUpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut
        >
      >,
      TError,
      {
        data: CompanyGlMappingsRequest;
        params?: UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut
      >
    >,
    TError,
    {
      data: CompanyGlMappingsRequest;
      params?: UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutParams;
    },
    TContext
  > => {
    const mutationKey = [
      'updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut
        >
      >,
      {
        data: CompanyGlMappingsRequest;
        params?: UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut(
        data,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut
      >
    >
  >;
export type UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutMutationBody =
  CompanyGlMappingsRequest;
export type UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Company Gl Mappings
 */
export const useUpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut
          >
        >,
        TError,
        {
          data: CompanyGlMappingsRequest;
          params?: UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutParams;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPut
      >
    >,
    TError,
    {
      data: CompanyGlMappingsRequest;
      params?: UpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutParams;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateCompanyGlMappingsApiV1AccountingSettingsCompanyGlMappingsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Configured GL roles that resolve to nothing, across every company.

Tenant-wide on purpose: the tab edits one company at a time, but a role
silently lost on a DIFFERENT company is exactly the state this surfaces (see
``GlRoleCoverageService``). Read-only; requires module admin.
 * @summary Get Gl Mappings Coverage
 */
export const getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet =
  (signal?: AbortSignal) => {
    return customInstance<GlMappingsCoverageEnvelope>({
      url: `/api/v1/accounting/settings/gl-mappings-coverage`,
      method: 'GET',
      signal
    });
  };

export const getGetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGetQueryKey =
  () => {
    return [`/api/v1/accounting/settings/gl-mappings-coverage`] as const;
  };

export const getGetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
        >
      >
    > = ({ signal }) =>
      getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
      >
    >
  >;
export type GetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGetQueryError =
  unknown;

export function useGetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Gl Mappings Coverage
 */

export function useGetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetGlMappingsCoverageApiV1AccountingSettingsGlMappingsCoverageGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
